import s from './index.module.scss';

export const Card = ({ image }) => {
  return (
    <div className={s.slide}>
      <img src={image.file} alt={image.name} width={290} height={180} />
    </div>
  );
};
